import { createAsyncThunk } from '@reduxjs/toolkit';
import { ConversationsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IGetConversationsDTO, IGetConversationsResponse } from '@/models/conversation.model';
import { SLICE_NAME } from './models';

export const getConversations = createAsyncThunk<
  IGetConversationsResponse,
  IGetConversationsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getConversations`,
  async (params) => {
    const response = await ConversationsAPI.getConversations(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
